export const removeScrollMixin = {
    beforeCreate() {
        document.body.className = 'lx-overflow-y-hidden';
    },
    beforeUnmount() {
        document.body.classList.remove('lx-overflow-y-hidden');
    },
}